// projectSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';


import Axios from '../../utils/Axios';
import AuthHandler from '../../utils/AuthHandler';
import { navigate } from '../../utils/navigation';
import { FETCH_PROJECTS, FORGOT_PASS_AUTH_TOKEN, FORGOT_PASS_CHANGE, FORGOT_PASS_REQUEST } from '../../config/API_Collection';
import { GET_USER_FORGOT_AUTH_FAILURE, GET_USER_FORGOT_AUTH_REQUEST, GET_USER_FORGOT_AUTH_SUCCESS, GET_USER_FORGOT_EMAIL_FAILURE, GET_USER_FORGOT_EMAIL_REQUEST, GET_USER_FORGOT_EMAIL_SUCCESS, USER_FORGOT_PASS_CHANGE_FAILURE, USER_FORGOT_PASS_CHANGE_REQUEST, USER_FORGOT_PASS_CHANGE_SUCCESS } from '../Actions/Actions';
import { getErrorMessage } from '../../config/Error_Codes';



function* fetchProjectsSaga(action) {
  try {

    
  const response = yield call(Axios.post,FORGOT_PASS_REQUEST,action?.payload);
   yield put({type:GET_USER_FORGOT_EMAIL_SUCCESS,payload:response?.data?.data?.OTP_info});
   navigate("/auth-reset-password")
  } catch (error) {
   
    yield put({type:GET_USER_FORGOT_EMAIL_FAILURE,payload:getErrorMessage(error.status)});
     navigate("/auth-reset-password")
  }
}

function* fetchForgotPassAuth(action) {
  try {

    
  const response = yield call(Axios.post,FORGOT_PASS_AUTH_TOKEN,action?.payload);
   yield put({type:GET_USER_FORGOT_AUTH_SUCCESS,payload:response?.data?.data?.OTP_info});
  navigate("/reset-password")
  } catch (error) {
   
    yield put({type:GET_USER_FORGOT_AUTH_FAILURE,payload:getErrorMessage(error.status)});
  }
}


function* changePasswordUser(action) {
  try {

    
  const response = yield call(Axios.post,FORGOT_PASS_CHANGE,action?.payload);
   yield put({type:USER_FORGOT_PASS_CHANGE_SUCCESS,payload:response?.data?.data});
      navigate("/login")
  } catch (error) {
   
    yield put({type:USER_FORGOT_PASS_CHANGE_FAILURE,payload:getErrorMessage(error.status)});
  }
}

export  function* SetChangePasswordUser() {
  yield takeLatest(USER_FORGOT_PASS_CHANGE_REQUEST, changePasswordUser);
}
export  function* forgotPasswordSaga() {
  yield takeLatest(GET_USER_FORGOT_EMAIL_REQUEST, fetchProjectsSaga);
}
export  function* forgotPasswordAuthSaga() {
  yield takeLatest(GET_USER_FORGOT_AUTH_REQUEST, fetchForgotPassAuth);
}

